/**
 * Shared helper for resolving a collection field's storage key: blockchain
 * fields are written keyed by `sanitizedName` when a collection defines one,
 * falling back to a lower-snake-cased version of the field's display name.
 * Used to look field values back up from the flat fields record returned by
 * the product/share APIs.
 */
export interface FieldKeyDef {
  name: string;
  sanitizedName?: string;
}

export const getFieldKey = (field: FieldKeyDef): string =>
  field.sanitizedName || field.name.toLowerCase().replace(/\s+/g, '_');
